import { lazy, Suspense, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, FolderKanban, Plus, ShoppingCart, Ticket } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ROUTES } from '@/lib/routes';

// The CSP request dialog fetches CSP data as soon as it renders, so it's loaded (and mounted) only on demand.
const RequestDialog = lazy(() => import('@/components/csp/CspKit').then((m) => ({ default: m.RequestDialog })));

/** Header "New" menu: quick create for the records people make most, from any page. */
export function NewMenu() {
  const navigate = useNavigate();
  const [requestOpen, setRequestOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="h-8 gap-1 px-2.5" aria-label="New">
            <Plus className="h-4 w-4"/>
            <span className="hidden sm:inline">New</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52">
          <DropdownMenuItem onSelect={() => navigate(ROUTES.psa.tickets.new)}>
            <Ticket className="mr-2 h-4 w-4"/> New ticket
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => navigate(ROUTES.psa.opportunities.new)}>
            <Briefcase className="mr-2 h-4 w-4"/> New opportunity
          </DropdownMenuItem>
          <DropdownMenuItem disabled>
            <FolderKanban className="mr-2 h-4 w-4"/> New project
            <span className="ml-auto rounded-full bg-muted px-1.5 py-0.5 text-[10px] text-muted-foreground">Soon</span>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setRequestOpen(true)}>
            <ShoppingCart className="mr-2 h-4 w-4"/> New CSP request
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {requestOpen && (
        <Suspense fallback={null}>
          <RequestDialog open onOpenChange={(o) => { if (!o) setRequestOpen(false); }} />
        </Suspense>
      )}
    </>
  );
}
